import { useSnackbarContext } from '@/context/Snackbar/SnackbarContext';
import { newPasswordResetRequest } from '@/data/api/request/sellerNewPasswordResetRequest';
import { useMutation } from '@tanstack/react-query';
import { useSearchParams } from 'react-router-dom';

export function useNewSellerPasswordReset() {
  const { showSnackSuccess, showSnackError } = useSnackbarContext();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';

  const { isPending, mutate } = useMutation({
    mutationFn: ({ password }: { password: string }) =>
      newPasswordResetRequest(password, token),
    onSuccess: () =>
      showSnackSuccess('La contraseña se ha cambiado exitosamente.'),
    onError: () => showSnackError('Hubo un problema al cambiar la contraseña.'),
  });

  return { resetPassword: mutate, isSending: isPending };
}
